import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ad-section-header-status',
  templateUrl: './header-status.component.html',
  styleUrls: ['./header-status.component.css'],
  animations: [
    trigger("showAndHide", [
      transition(":enter", [
        style({ opacity: 0, height: '0px' }),
        animate('300ms cubic-bezier(0, 0, 0.2, 1)'),
      ]),
      transition(":leave", [
        animate('300ms linear', style({ opacity: 0, height: "0px" })),
      ])
    ])

  ],
  host: { '[@showAndHide]': "" }
})
export class HeaderStatusComponent implements OnInit {
  @Input() title: string = "EDIT MODEL";
  constructor() { }

  ngOnInit(): void {
  }
}
